var React = require('react');
var Frame = require('../../views/Frame');

var createSprite = require('../../../lib/createSprite');
var spritesHelper = require('../../../lib/spritesHelper');
var Utils = require('../../../lib/utils');

var Blobs = require('../../../lib/blobs');
var BlobsAnimations = require('../../../animations/blobs');

var PipeFlow = React.createClass({

    propTypes: {
        index: React.PropTypes.number,
        play: React.PropTypes.bool,
        storyWidth: React.PropTypes.number,
        storyHeight: React.PropTypes.number,
        width: React.PropTypes.number,
        height: React.PropTypes.number,
        border: React.PropTypes.number,
        objs: React.PropTypes.object,
        container: React.PropTypes.object
    },

    contextTypes: {
        cleanTint: React.PropTypes.number,
        dirtyTints: React.PropTypes.array
    },

    sprites: null,
    timeline: null,
    movieclipTimeline: null,

    getDefaultProps: function()
    {
        return {
            className: 'pipe-flow',
            blobsRow: 5,
            blobsGroupsCount: 15,
            blobsGroupsStagger: 0.2,
            blobsGroupsMinBlobsCount: 4,
            blobsGroupsMaxBlobsCount: 8,
            paintableBlobsProbabilities: {
                '1': 1/10,
                '2': 3/10,
                '3': 8/10
            }
        }
    },

    render: function()
    {
        return (
            <Frame
                onBuild={this.build}
                onPlay={this.play}
                onPause={this.pause}
                onDestroy={this.destroy}
                onIntensityChanged={this.updateIntensity}
                {...this.props}
            />
        );
    },

    build: function(container, timeline)
    {
        this.sprites = {
            container: container
        };
        this.timeline = timeline;

        this.buildObjects();
        this.animateObjects();
    },

    play: function()
    {

    },

    pause: function()
    {

    },

    destroy: function()
    {
        if (this.sprites) {
            Object.keys(this.sprites).forEach(key => (
                TweenMax.killTweensOf(this.sprites[key])
            ));
        }
        this.sprites = null;
        // this.timeline = null;
        this.movieclipTimeline = null;
    },

    buildObjects: function()
    {
        var props = this.props;
        var state = this.state;
        var context = this.context;
        var sprites = this.sprites;
        var objs = props.objs;
        var container = sprites.container;

        // frame mask
        var pipeBlobsMask = spritesHelper.createFrameMaskFromSize(props.width, props.height);
        container.addChild(pipeBlobsMask);

        // pipeBig
        var pipeBigKey = 'pipeBig';
        var pipeBigObject = objs[pipeBigKey];
        var pipeBig = sprites[pipeBigKey] = createSprite(pipeBigObject);
        Utils.setSizeAndPositionFromRefSize(pipeBig, props.width, props.height, pipeBigObject);

        // blobs
        var pipeBlobsGroups = sprites.pipeBlobsGroups = [];
        var pipeBlobsGroupsContainer = new PIXI.Sprite();
        for (var i = 0; i < props.blobsRow; i++)
        {
            var pipeBlobsGroup = [];
            pipeBlobsGroups.push(pipeBlobsGroup);

            var pipeBlobsContainer = sprites['pipeBlobs'+i] = Blobs.createBlobs({
                group: pipeBlobsGroup,
                y: pipeBig.y + pipeBig.height * 0.93 - pipeBig.height / 28 * i,
                blobObject: {
                    scale: {
                        x: '3.2%'
                    }
                },
                width: props.width,
                height: props.height,
                groupsCount: props.blobsGroupsCount,
                minBlobsCount: props.blobsGroupsMinBlobsCount,
                maxBlobsdCount: props.blobsGroupsMaxBlobsCount,
                cleanTint: context.cleanTint,
                dirtyTints: context.dirtyTints,
                objectsWithTextures: objs
            });
            pipeBlobsGroupsContainer.addChild(pipeBlobsContainer);
        }
        container.addChild(pipeBlobsGroupsContainer);
        pipeBlobsGroupsContainer.mask = pipeBlobsMask;

        container.addChild(pipeBig);
    },

    animateObjects: function()
    {
        var timeline = this.timeline;

        var props = this.props;
        var state = this.state;
        var context = this.context;

        var sprites = this.sprites;
        var objects = this.objects;

        var width = props.width;

        var movieclipTimelines = this.movieclipTimelines = [];

        sprites.pipeBlobsGroups.map(function(pipeBlobsGroups, pipeIndex){
            pipeBlobsGroups.map(function(blobGroup, blobGroupIndex){
                blobGroup.map(function(blob, blobIndex){
                    movieclipTimelines.push(timeline.add(BlobsAnimations.getPaintBlobTimeline(blob, {
                        duration: 0.7,
                        width: width + width * 0.25,
                        height: -sprites.pipeBig.height * 0.8,
                        cleanTint: context.cleanTint,
                        dirtyTints: context.dirtyTints,
                        animScale: false
                    }), blobGroupIndex * props.blobsGroupsStagger + pipeIndex * 0.07));
                });
            });
        });

        if (this.props.onAnimationReady)
        {
            this.props.onAnimationReady(timeline);
        }
    },

    updateIntensity: function(prevIntensity)
    {
        var props = this.props;
        var sprites = this.sprites;
        var context = this.context;
        var intensity = props.intensity;
        prevIntensity = typeof prevIntensity !== 'undefined' ? prevIntensity:intensity;

        var paintableBlobsProbability = props.paintableBlobsProbabilities[intensity];

        // movieclip timelines
        _.each(this.movieclipTimelines, function(movieclipTimeline){
            movieclipTimeline.timeScale(1 + (intensity-2) * 0.15);
        });

        sprites.pipeBlobsGroups.map(function(blobsGroups, painterIndex){
            blobsGroups.map(function(blobGroup, blobGroupIndex){
                blobGroup.map(function(blob, blobIndex){
                    blob.paintable = _.random(0, 1, true) < paintableBlobsProbability;
                });
            });
        });
    }
});

module.exports = PipeFlow;



// WEBPACK FOOTER //
// ./js/components/frames/_common/PipeFlow.jsx